import Configs from "../config";

export default function getImageUrl(
  image: string | undefined | null,
  thumbVideo?: boolean
): string {
  if (image) return `${Configs.BUCKET_URL}/file/local/${image}`;
  else if (thumbVideo) return "./icons/login/logo.svg";
  return "./images/profile.jpg";
}
